import { AxiosResponse } from 'axios'
import { Dialog } from 'vant'
import IRequestResult from '@/store/models/request-result'
import cookie from 'js-cookie'
import moment from 'moment'
import { pinyin } from '@/lib/pinyin'

class Util {
	isPhone(value: string) {
		return /^1[3456789]\d{9}$/.test(value)
	}
	// 验证手机号码
	phoneValidater(rule: any, value: string, callback: any) {
		if (/^1[3456789]\d{9}$/.test(value))
			return callback()
		return callback(new Error('请输入正确的手机号码'))
	}
	// 验证手机号码
	truckNumberValidater(rule: any, value: string, callback: any) {
		let exp = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
		if (exp.test(value))
			return callback()
		return callback(new Error('请输入正确的车牌号码'))
	}
	IdValidater(rule: any, value: string, callback: any) {
		let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
		if (reg.test(value))
			return callback()
		return callback(new Error('请输入正确的身份证号码'))
	}
	/**
	 * 获取今天的日期
	 */
	public nowDate() {
		return moment().format('YYYY-MM-DD')
	}

	/**
	 * 获取今天的日期时间
	 */
	public nowDateTime() {
		return moment().format('YYYY-MM-DD HH:mm')
	}

	/**
	 * 获取当月1号的日期
	 */
	public firstDayOfCurrentMonth() {
		return this.formatDate(moment().startOf('month'))
	}

	/**
	 * 格式化日期
	 * @param value 要格式化的日期
	 */
	public formatDate(value: any) {
		if (!value) return ''
		return moment(value).format('YYYY-MM-DD')
	}
	// 格式化时间
	public formatDateTime(value: any) {
		if (!value) return ''
		return moment(value).format('YYYY-MM-DD HH:mm')
	}
	public formatDateTime2(value: any) {
		if (!value) return ''
		return moment(value).format('YYYY-MM-DD HH:mm:ss')
	}
	// 给指定的日期加上指定的天数
	public addDay(date: any, num: number) {
		return this.formatDate(moment(date).add(num, 'days'))
	}
	// 给指定的日期加上指定的月数
	public addMonths(date: any, num: number) {
		return this.formatDate(moment(date).add(num, 'months'))
	}
	// 保留三位
	public roundingThreeFormat(cellValue: any) {
		if (!cellValue) return '0.000'
		return cellValue.toFixed(3)
	}

	// 保留两位
	public roundingTwoFormat(cellValue: any) {
		if (!cellValue) return '0.00'
		return cellValue.toFixed(3)
	}
	title(title: string) {
		window.document.title = title
	}
	// 检查云仓api调用是否成功
	// checkApiResponseIsSuccess(rep: AxiosResponse) {
	// 	let result = rep.data as IRequestResult<any>
	// 	if(result.code !== '200') {
	// 		Dialog.alert({
	// 			title: '提示信息',
	// 			message: result.msg
	// 		})
	// 		return false
	// 	}
	// 	return true
	// }
	getWxOpenId() {
		return cookie.get('openid')
	}
	setWxOpenId(openid: string) {
		cookie.set('openid', openid)
	}
	getHeadimgurl() {
		return cookie.get('headimgurl')
	}
	setHeadimgurl(headimgurl: string) {
		cookie.set('headimgurl', headimgurl)
	}
	convertEnumToObjectArray(obj: any) {
		let names = Object.keys(obj).filter((k: any) => typeof obj[k] === 'number') as string[]
		let res: Array<any> = []
		names.forEach((item) => {
			res.push({
				text: item,
				value: obj[item]
			})
		})
		return res
	}
	// 名字转为拼音
	chineseToPinYin(l1: string) {
		let l2 = l1.length
		let I1 = ''
		let reg = new RegExp('[a-zA-Z0-9]')
		for (let i = 0; i < l2; i++) {
			let val = l1.substr(i, 1)
			let name = this.arraySearch(val)
			if (reg.test(val)) {
				I1 += val
			} else if (name !== false) {
				I1 += name
			}
		}
		I1 = I1.replace(/ /g, '-')
		while (I1.indexOf('--') > 0) {
			I1 = I1.replace('--', '-')
		}
		return I1
	}
	// 首字母转为拼音
	chineseToPinYinToFirst(l1: string) {
		let l2 = l1.length
		let I1 = ''
		let reg = new RegExp('[a-zA-Z0-9]')
		for (let i = 0; i < l2; i++) {
			let val = l1.substr(i, 1)
			let name = this.arraySearch(val)
			if (reg.test(val)) {
				I1 += val
			} else if (name !== false) {
				I1 += name
			}
		}
		I1 = I1.replace(/ /g, '-')
		while (I1.indexOf('--') > 0) {
			I1 = I1.replace('--', '-')
		}
		return I1[0]
	}
	arraySearch(l1: any) {
		let obj: any = pinyin
		for (let name in obj) {
			if (obj[name].indexOf(l1) !== -1) {
				return this.ucfirst(name)
			}
		}
		return false
	}
	ucfirst(l1: any) {
		if (l1.length > 0) {
			let first = l1.substr(0, 1).toUpperCase()
			let spare = l1.substr(1, l1.length)
			return first + spare
		}
	}

	// 将指定的number集合按位或运算，返回运算后的结果
	convertNubmersToHexValue(arr: Array<number>) {
		if (!arr || arr.length === 0) return 0
		let res: number = 0
		arr.forEach((v) => {
			// tslint:disable-next-line: no-bitwise
			res = res | v
		})
		return res
	}
	// 将指定的值转换成对应枚举中的多个值(位运算的结果值)
	// 如enumType {a:1, b: 2, c:4} 传入值为7那么返回的数据就是[1, 2, 4]
	convertValueToHexArray(enumType: any, value: number): Array<number> {
		let enumObjs = this.convertEnumToObjectArray(enumType)
		let arr = []
		for (let i = 0; i < enumObjs.length; i++) {
			let currentEnumObj = enumObjs[i]
			let v = parseInt(currentEnumObj.value, 10)
			// tslint:disable-next-line: no-bitwise
			if ((v & value) === v) {
				arr.push(v)
			}
		}
		return arr
	}

	// 字符串转日期格式，strDate要转为日期格式的字符串
	stringToDate(strDate: any) {
		let date = this.evil('new Date(' + strDate.replace(/\d+(?=-[^-]+$)/, this.timeInt).match(/\d+/g) + ')')
		return date
	}
	// 时间相减 返回天/小时
	datetimedif(beginTime: any, endTime: any) {
		let dateBegin = new Date(beginTime)
		let dateEnd = new Date(endTime)
		let dateDiff = dateEnd.getTime() - dateBegin.getTime()// 时间差的毫秒数
		let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
		let leave1 = dateDiff % (24 * 3600 * 1000)    // 计算天数后剩余的毫秒数
		let hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
		// 计算相差分钟数
		let leave2 = leave1 % (3600 * 1000)   // 计算小时数后剩余的毫秒数
		let minutes = Math.floor(leave2 / (60 * 1000)) // 计算相差分钟数
		// 计算相差秒数
		let leave3 = leave2 % (60 * 1000)     // 计算分钟数后剩余的毫秒数
		let seconds = Math.round(leave3 / 1000)
		return dayDiff + '天' + hours + '小时'
	}
	timeInt(a: any) { return parseInt(a, 10) - 1 }
	// 计算表达式的值
	evil(fn: any) {
		let Fn = Function  // 一个变量指向Function，防止有些前端编译工具报错
		return new Fn('return ' + fn)()
	}
	stringToDateFunction(dateStr: any, separator: any | null) {
		if (!separator) {
			separator = '-'
		}
		let dateArr = dateStr.split(separator)
		let year = parseInt(dateArr[0], 0)
		let month = 0
		// 处理月份为04这样的情况
		if (dateArr[1].indexOf('0') === 0) {
			month = parseInt(dateArr[1].substring(1), 0)
		} else {
			month = parseInt(dateArr[1], 0)
		}
		let day = parseInt(dateArr[2], 0)
		let date = new Date(year, month - 1, day)
		return date
	}
	/**
	 * 计算工龄
	 * @method dateToWorkingAge
	 * @for util
	 * @param { string } date 需要计算的时间
	 * @return { string } `输出**年**月`
	 */
	dateToWorkingAge(date: string) {
		let date1 = new Date(date)
		let date2 = new Date()
		let monthCount = (date2.getFullYear() - date1.getFullYear()) * 12 - date1.getMonth() + date2.getMonth()
		let resM = monthCount % 12
		let resY = monthCount / 12
		let resStr = ''
		if (resY !== 0) {
			resStr += resY.toFixed(0) + '年'
		}
		if (resM !== 0) {
			resStr += resM + '月'
		}
		if (resStr === '') {
			resStr = '0'
		}
		return resStr
	}

	// 将base64转换为file文件
	dataURLtoFile (dataurl: any, filename: any) {
		let arr = dataurl.split(',')
		let mime = arr[0].match(/:(.*?);/)[1]
		let bstr = atob(arr[1])
		let n = bstr.length
		let u8arr = new Uint8Array(n)
		while (n--) {
		  u8arr[n] = bstr.charCodeAt(n)
		}
		return new File([u8arr], filename, {type: mime})
	  }
}
const util = new Util()
export default util
